import Vue from "vue";
import _ from "lodash";
import qs from "qs";

const URL = "/db/trainer_divisi";
const API_URL = URL + "/api/";

const state = {
  trainer_divisi: [],
  trainer_divisi_loaded: false
};

const getters = {
  trainer_divisiInjected(state) {
    return state.trainer_divisi;
  }
};

const mutations = {
  LOADED(state, payload) {
    state.trainer_divisi_loaded = payload;
  },
  SET_TRAINER_DIVISI(state, payload) {
    state.trainer_divisi = payload;
  },
  ADD_TRAINER_DIVISI(state, payload) {
    state.trainer_divisi.push(payload);
  },
  UPDATE_TRAINER_DIVISI(state, payload) {
    state.trainer_divisi = _.unionBy(
      [payload],
      state.trainer_divisi,
      "id_trainer_divisi"
    );
  },
  DELETE_TRAINER_DIVISI(state, ids) {
    _.remove(state.trainer_divisi, function(divisi) {
      return ids.includes(divisi.id_trainer_divisi);
    });
    state.trainer_divisi = [...state.trainer_divisi];
  }
};

const actions = {
  GET_TRAINER_DIVISI({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("LOADED", true);
      commit("SET_TRAINER_DIVISI", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_TRAINER_DIVISI({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_TRAINER_DIVISI", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, { root: true });
        throw e;
      });
  },
  UPDATE_TRAINER_DIVISI({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_trainer_divisi, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_TRAINER_DIVISI", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_TRAINER_DIVISI({ commit }, payload) {
    let ids = payload.map(p => p.id_trainer_divisi).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_TRAINER_DIVISI", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
